export default __webpack_public_path__ + "static/media/e-VBAB.95779aed.png";